import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {FireInTheHole2} from "../FireInTheHole2";
import {gsap} from "gsap";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";
import {IBetWayWinData} from "@nolimitcity/slot-game/bin/utils/server/IData";
import {FITH2GameAssets} from "../FITH2GameAssets";
import {FITH2Symbol} from "../symbols/FITH2Symbol";
import {FITH2GameConfig} from "../configs/FITH2GameConfig";
import {BitmapText} from "pixi.js";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {FITH2Helper} from "../utils/FITH2Helper";


export class FITH2InitialWinView extends PIXI.Container implements StageLayer {

    public static DELAY_BETWEEN_COMBO_WINS: number = 0;
    private static WIN_ABOVE_LEVEL_01: number = 50;

    private readonly _maxWinNumberWidth: number = 130;

    constructor() {
        super();
        this.name = "FITH2InitialWinView";
    }

    //Counts all the wins that are below 50 * base bet
    private calculateAboveLevel01LingerTime(): number {
        const winData: IBetWayWinData[] = FireInTheHole2.model.gameData.betWayWins;
        let belowLevelWins: number = 0;
        for (let i: number = 0; i < winData.length; i++) {
            if (winData[i].multipliedAmount < (FITH2InitialWinView.WIN_ABOVE_LEVEL_01 * FireInTheHole2.model.gameData.playedBetValue)) {
                belowLevelWins++;
            }
        }
        return 0.5;// + (belowLevelWins * FITH2InitialWinView.DELAY_BETWEEN_COMBO_WINS);
    }

    private getStartPosition(symPosition: number[], textWidth:number): number[] {
                const sym: FITH2Symbol = FireInTheHole2.reelArea.getSymbol(symPosition),
                reelId = symPosition[0],
                    symId = symPosition[1];
                const viewPosition: PIXI.Point = FITH2GameConfig.reelPositions[reelId];
                let x = viewPosition.x - ((reelId===5 && (textWidth>FITH2GameConfig.symbolWidth))?4:0);
                return [x, sym.position.y + 50, symId === 0 ? 10 : 100];
    }

    public playWinNumbers(betWayWinData: IBetWayWinData, skipped: boolean, symPosition:number[]): gsap.core.Timeline {
        let text = FireInTheHole2.apiPlugin.currency.formatValue(MathHelper.roundToDecimals(betWayWinData.amount, 2)),
            totalWinWays: number = betWayWinData.numberOfCombinations;
        if (betWayWinData.multiplier > 1) {
            text += ` x ${betWayWinData.multiplier}`;
        }
        let startScale = 1;
        let endScale = startScale;
        let lingerTime = 0;
        const winAboveLevel01LingerTime = this.calculateAboveLevel01LingerTime();
        const textHolder: PIXI.Sprite = new PIXI.Sprite();
        const winNumber = new PIXI.BitmapText(text, {
                fontName: FITH2GameAssets.BITMAP_FONT_WIN_COUNT_UP,
                fontSize: 20
            }),
            waysNumber = new BitmapText(totalWinWays.toString(), {
                fontName: FITH2GameAssets.BITMAP_FONT_WIN_WAYS,
                fontSize: 24,
                tint: 0xffffff
            }),
            waysText = new PIXI.Sprite(FireInTheHole2.assetLoader.getTextures(`Way${totalWinWays > 1 ? "s" : ""}`)[0]);
        winNumber.anchor = new PIXI.Point(0, 1);
        winNumber.position.set(0, 0);

        waysNumber.anchor = new PIXI.Point(0, 0);
        waysText.scale.set(0.5);
        waysText.anchor = new PIXI.Point(0, 0);
        waysNumber.letterSpacing = -12;

        textHolder.alpha = 0;
        textHolder.visible = false;
        textHolder.addChild(winNumber, waysText, waysNumber);
        textHolder.anchor.set(1, 0.1);
        if(!FITH2Helper.isWinBelowStake(betWayWinData.amount)){
            this.addChild(textHolder);
        }
        winNumber.updateTransform();
        if (winNumber.width > this._maxWinNumberWidth) {
            const scale: number = MathHelper.roundToDecimals(this._maxWinNumberWidth / winNumber.width, 2);
            winNumber.scale.set(scale);
        }
        const startPos:number = (winNumber.width-waysNumber.width-waysText.width)*0.5;
        waysNumber.position.set(startPos, 28);
        waysText.position.set(startPos + waysNumber.width-6, 30);
        const startPositions = this.getStartPosition(symPosition, winNumber.width);
        textHolder.position.set(startPositions[0], startPositions[1]);

        const timeline = gsap.timeline();
        timeline.add([
            ()=>{textHolder.visible = true;},
            gsap.to(textHolder, {duration: 0, alpha: 1}),
            gsap.to(textHolder, {duration: 0.8, y: startPositions[1] - startPositions[2]})
        ], 0);
        timeline.add(gsap.to(textHolder, {duration: 0.4, alpha: 0, delay: lingerTime}));
        timeline.add(() => {
            if (winNumber.parent) {
                this.removeChild(winNumber);
            }
            winNumber.destroy();
            if (waysNumber.parent) {
                this.removeChild(waysNumber);
            }
            waysNumber.destroy();
            waysText.destroy();
            textHolder.destroy();
        });
        if (skipped) {
            timeline.timeScale(4);
        }
        return timeline;
    }

    public findLastNoWildSymbolPosition(betWayWinData: IBetWayWinData): number[] {
        for (let reelId = 5; reelId > -1; reelId--) {
            for (let symId = 0; symId <= FireInTheHole2.model.barId; symId++) {
                if (!betWayWinData.reelWinPositions[reelId][symId]) {
                    continue;
                }
                const sym: FITH2Symbol = FireInTheHole2.reelArea.getSymbol([reelId, symId]);
                if (!sym) {
                    continue;
                }

                if (!sym.visible) {
                    continue;
                }

                if (sym.name === "W" || sym.name === "Y" || sym.name === "FW") {
                    continue;
                }

                return [reelId,symId];
            }
        }
        debugger
        return [0, 0];
    }

    public addMultiValue(): gsap.core.Timeline {
        const effect: TimelineSprite = new TimelineSprite(FireInTheHole2.assetLoader.getTextures("freespin/refresh/refresh_"));
        effect.anchor.set(0.5);
        effect.position.set(FireInTheHole2.multiplier.position.x, FireInTheHole2.multiplier.position.y);
        effect.blendMode = PIXI.BLEND_MODES.ADD;
        return gsap.timeline().add([
            () => {
                this.addChild(effect);
            },
            gsap.to(effect, 0.2,{x:FireInTheHole2.multiplier.position.x, y:FireInTheHole2.multiplier.position.y}),
            effect.getAnimationAutoShowHide(true, true)]
        ).add(() => {
            this.removeChild(effect);
            effect.destroy();
        });
    }

    public addMulti(bomb:number[]): gsap.core.Timeline {
        const effect: TimelineSprite = new TimelineSprite(FireInTheHole2.assetLoader.getTextures("mult_dot/mult_dot_"));
        effect.anchor.set(0.5);
        effect.position.set(FITH2GameConfig.reelAreaPos.x+bomb[0]*FITH2GameConfig.symbolWidth, FITH2GameConfig.reelAreaPos.y+bomb[1]*FITH2GameConfig.symbolHeight);
        effect.blendMode = PIXI.BLEND_MODES.ADD;
        return gsap.timeline().add([
            () => {
                this.addChild(effect);
            },
            gsap.to(effect, 0.2,{x:FireInTheHole2.multiplier.position.x, y:FireInTheHole2.multiplier.position.y}),
            effect.getAnimationAutoShowHide(true, true)]
        ).add(() => {
            this.removeChild(effect);
            effect.destroy();
        });
    }
}